import React, { useState } from "react";
import GuideFlowTabs from "../components/guides/GuideFlowTabs";
import GuideSection from "../components/guides/GuideSection";
import {
    DEFAULT_GUIDE_KEY,
    guidesData,
} from "../components/guides/guidesData";
import PageContainer from "../components/layout/PageContainer";

function Guides() {
    const [activeGuideTab, setActiveGuideTab] = useState(DEFAULT_GUIDE_KEY);
    const selectedGuide =
        guidesData[activeGuideTab] || guidesData[DEFAULT_GUIDE_KEY];

    return (
        <main className="min-h-screen bg-[#F8F8FE]">
            <PageContainer className="py-4">
                <header className="mb-5">
                    <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
                        Application Guide
                    </h1>
                    <p className="mt-2 max-w-2xl text-sm font-medium text-slate-600">
                        Learn how to use OptiMind and understand the features
                        that support your outreach workflow.
                    </p>
                </header>

                <GuideFlowTabs
                    activeTab={activeGuideTab}
                    onTabChange={setActiveGuideTab}
                />

                <GuideSection
                    guide={selectedGuide}
                    onSelectGuide={setActiveGuideTab}
                />
            </PageContainer>
        </main>
    );
}

export default Guides;
